import * as React from 'react';
import clsx from 'clsx';

import { ifClickable } from '../../utils/touchUtils';

interface Props {
  'aria-label'?: string;
  className?: string;
  disabled?: boolean;
  icon?: string;
  Icon?: React.ComponentClass | React.FC<React.PropsWithChildren<unknown>>;
  iconClassName?: string;
  children?: React.ReactNode;
  onClick?(): void;
  tabIndex?: number;
  text?: string | JSX.Element;
  'data-testid'?: string;
}

/**
 * @deprecated Prefer a Pantry component instead. See https://docs.tocktix.com/pantry.
 * If an equivalent component doesn't exist yet, reach out in #pantry-design-system on Slack.
 */
export default class TextInputAffix extends React.PureComponent<Props> {
  render() {
    const {
      disabled,
      children,
      className: classNameFromProps,
      icon,
      Icon,
      iconClassName,
      onClick,
      text,
    } = this.props;
    let content;
    const iconClass = iconClassName || 'icon';
    if (Icon) {
      content = (
        <div className="TextInput-affixIconComponent">
          <Icon />
        </div>
      );
    } else if (icon) {
      const fullIconClassName = clsx('TextInput-affixIcon', iconClass, icon);
      content = (
        <div className="TextInput-affixIconContainer">
          <i className={fullIconClassName} />
        </div>
      );
    } else if (text) {
      content = <div className="TextInput-affixText">{text}</div>;
    } else if (children) {
      content = <div className="TextInput-affixIconComponent">{children}</div>;
    }

    const className = clsx('TextInput-affix', classNameFromProps);
    return (
      <button
        type="button"
        aria-label={this.props['aria-label']}
        disabled={disabled}
        className={className}
        onClick={ifClickable(onClick)}
        data-testid={this.props['data-testid']}
      >
        {content}
      </button>
    );
  }
}
